var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgServices(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 200,
    viewBox: "0 0 198 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2220_23472)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99 192.589C152.182 192.589 195.294 149.476 195.294 96.2944C195.294 43.1125 152.182 0 99 0C45.8181 0 2.70557 43.1125 2.70557 96.2944C2.70557 149.476 45.8181 192.589 99 192.589Z",
    fill: "#C1E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.21 116.864H0.79541V121.553H197.21V116.864Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.822 121.553H14.1162V134.678H183.822V121.553Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.263 162.642H94.6753V185.856H103.263V162.642Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7037 134.683H14.1162V199.793H22.7037V134.683Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.817 134.683H175.229V199.793H183.817V134.683Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.263 134.683H94.6753V144.262H103.263V134.683Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0723 185.855H128.364C130.426 185.855 132.095 187.525 132.095 189.586V192.908H66.3359V189.586C66.3359 187.525 68.0053 185.855 70.0667 185.855H70.0723Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3416 199.787C68.1855 199.787 69.6802 198.292 69.6802 196.449C69.6802 194.605 68.1855 193.11 66.3416 193.11C64.4977 193.11 63.0029 194.605 63.0029 196.449C63.0029 198.292 64.4977 199.787 66.3416 199.787Z",
    fill: "#191A20",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.9666 199.787C100.81 199.787 102.305 198.292 102.305 196.449C102.305 194.605 100.81 193.11 98.9666 193.11C97.1227 193.11 95.6279 194.605 95.6279 196.449C95.6279 198.292 97.1227 199.787 98.9666 199.787Z",
    fill: "#191A20",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.101 199.787C133.945 199.787 135.44 198.292 135.44 196.449C135.44 194.605 133.945 193.11 132.101 193.11C130.257 193.11 128.762 194.605 128.762 196.449C128.762 198.292 130.257 199.787 132.101 199.787Z",
    fill: "#191A20",
    stroke: "#191A20",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.953 110.568C130.689 110.568 132.101 111.979 132.101 113.716V116.864H125.805V113.716C125.805 111.979 127.216 110.568 128.953 110.568Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.9779 107.554H23.3257V116.864H61.9779V107.554Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1239 98.2439H19.4717V107.554H58.1239V98.2439Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.5101 88.9392H23.8579V98.2493H62.5101V88.9392Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.9986 58.6226H113.934C120.309 58.6226 125.491 63.7986 125.491 70.179V116.864H72.4478V70.179C72.4478 63.8042 77.6238 58.6226 84.0042 58.6226H83.9986Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.2964 76.2345L80.0771 59.2388L97.1625 69.0699",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M102.879 67.4529L64.8984 77.6868L68.6265 91.5226L106.608 81.2888L102.879 67.4529Z",
    fill: "#0C57BF",
    stroke: "#0C57BF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.0583 80.8784L75.2318 84.1779L75.2766 84.1667L75.4951 80.223L76.4138 79.9766L76.0329 85.0182L75.0022 85.2982L72.1396 81.1305L73.0527 80.884L73.0583 80.8784Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.3184 84.4021L77.4277 84.643L77.8087 79.6014L78.8394 79.3213L81.7019 83.489L80.8112 83.7299L78.5929 80.4024L78.5593 80.4136L78.3184 84.4077V84.4021ZM77.8591 82.5871L80.2846 81.9317L80.4639 82.6039L78.0383 83.2593L77.8591 82.5871Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2143 79.2708L84.374 79.4949C84.3124 79.366 84.2339 79.254 84.1443 79.1644C84.0491 79.0747 83.9482 79.0075 83.8306 78.9571C83.713 78.9067 83.5897 78.8787 83.4553 78.8731C83.3209 78.8731 83.1864 78.8843 83.0464 78.9235C82.7943 78.9907 82.5926 79.1139 82.4302 79.2932C82.2677 79.4725 82.1669 79.6965 82.1221 79.9654C82.0773 80.2343 82.0997 80.5424 82.1949 80.8897C82.2901 81.2426 82.4246 81.5227 82.5982 81.7356C82.7719 81.9484 82.9735 82.0885 83.1976 82.1557C83.4217 82.2285 83.6626 82.2285 83.909 82.1557C84.0491 82.1165 84.1723 82.0661 84.2844 81.9932C84.3964 81.926 84.4916 81.842 84.5644 81.7412C84.6429 81.6459 84.6989 81.5339 84.7381 81.4107C84.7773 81.2874 84.7885 81.153 84.7773 81.0129L85.6176 80.7889C85.6456 81.0185 85.6344 81.237 85.5784 81.4611C85.5223 81.6851 85.4383 81.8868 85.3095 82.0773C85.1806 82.2677 85.0126 82.4358 84.8109 82.5758C84.6093 82.7159 84.3684 82.8279 84.0939 82.9007C83.6906 83.0072 83.304 83.0128 82.9343 82.9119C82.5646 82.8111 82.2453 82.6094 81.9652 82.3013C81.6851 81.9988 81.4835 81.5955 81.349 81.1026C81.2146 80.604 81.1922 80.1559 81.2818 79.7525C81.3714 79.3492 81.5507 79.0131 81.8196 78.7386C82.0885 78.4641 82.419 78.2737 82.8223 78.1672C83.08 78.1 83.3265 78.072 83.5673 78.0832C83.8082 78.0944 84.0323 78.1504 84.2395 78.2401C84.4468 78.3297 84.6373 78.4641 84.7997 78.6322C84.9678 78.8002 85.1022 79.0075 85.203 79.2596L85.2143 79.2708Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.3316 81.9707L86.4409 82.2116L86.8218 77.17L87.8526 76.8899L90.7151 81.0576L89.8244 81.2985L87.6061 77.971L87.5725 77.9822L87.3316 81.9763V81.9707ZM86.8722 80.1557L89.2978 79.5003L89.4771 80.1725L87.0515 80.8279L86.8722 80.1557Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8688 75.271L95.1068 79.8757L94.3618 80.0773L91.348 77.5229L91.3088 77.5341L92.1547 80.6711L91.32 80.8952L90.082 76.2905L90.8271 76.0889L93.8408 78.6433L93.88 78.6321L93.0342 75.4951L93.8632 75.271H93.8688Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7598 75.7808L94.5693 75.0806L98.2441 74.0891L98.4346 74.7893L97.0117 75.1703L98.0648 79.0747L97.2358 79.2988L96.1826 75.3943L94.7598 75.7752V75.7808Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.131 113.559H125.099L132.106 79.6011H181.139L174.131 113.559Z",
    fill: "#0C57BF",
    stroke: "#0C57BF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.131 113.559H106.809V116.707H174.131V113.559Z",
    fill: "#0C57BF",
    stroke: "#0C57BF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.113 95.2974L151.987 98.72L151.864 98.8601L150.222 97.426L149.102 98.6696L150.278 99.6948L151.987 101.174L152.009 101.196L157.135 95.331L155.113 95.2974Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.101 157.158H66.3418V162.642H132.101V157.158Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.6546 144.257H123.782C128.37 144.257 132.095 147.982 132.095 152.57V157.275H66.3359V152.57C66.3359 147.982 70.0611 144.257 74.649 144.257H74.6546Z",
    fill: "white",
    stroke: "#1F2025",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6253 104.686C27.6123 104.686 28.4123 103.886 28.4123 102.899C28.4123 101.912 27.6123 101.112 26.6253 101.112C25.6384 101.112 24.8384 101.912 24.8384 102.899C24.8384 103.886 25.6384 104.686 26.6253 104.686Z",
    fill: "#0C57BF",
    stroke: "#0C57BF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1825 113.996C31.1694 113.996 31.9694 113.196 31.9694 112.209C31.9694 111.222 31.1694 110.422 30.1825 110.422C29.1956 110.422 28.3955 111.222 28.3955 112.209C28.3955 113.196 29.1956 113.996 30.1825 113.996Z",
    fill: "#0C57BF",
    stroke: "#0C57BF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1825 95.3813C31.1694 95.3813 31.9694 94.5813 31.9694 93.5943C31.9694 92.6074 31.1694 91.8074 30.1825 91.8074C29.1956 91.8074 28.3955 92.6074 28.3955 93.5943C28.3955 94.5813 29.1956 95.3813 30.1825 95.3813Z",
    fill: "#0C57BF",
    stroke: "#0C57BF",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.1294 91.8074H40.9712V95.3757H58.1294V91.8074Z",
    fill: "#C1E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0737 101.118H36.9155V104.686H54.0737V101.118Z",
    fill: "#C1E8FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.9531 110.428H37.7949V113.996H54.9531V110.428Z",
    fill: "#C1E8FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2220_23472"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 196.835,
    height: 200,
    fill: "white",
    transform: "translate(0.58252)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgServices);
export default __webpack_public_path__ + "static/media/services.951c14c139df2bf2824acccdd25c95b6.svg";
export { ForwardRef as ReactComponent };